/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { SidebarWrapper } from "../Styles/LayoutStyle";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { UserData } from "../Context/PageContext";
import SkeletonLoader from "./Loader/SkeletonLoader";
import { toast } from "react-toastify";
import axiosInstance from "../Services/Middleware/AxiosInstance";
import { getApiEndpoints } from "../Services/Api/ApiConfig";
import ButtonLoader from "./Loader/ButtonLoader";

const Sidebar = () => {
    const api = getApiEndpoints();
    const navigate = useNavigate();
    const location = useLocation();
    const { setAuthToken, setPageName, isAuthLoading, userDetails, setUserDetails } = UserData();
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [failedProfileImage, setFailedProfileImage] = useState(null);
    const profileName = userDetails.name?.trim() || 'Super Admin';
    const profileInitials = profileName.split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase();

    useEffect(() => {
        const formatPathName = (pathName) => {
            return pathName.split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        };
        const path = location.pathname;
        const pathName = path.split('/').filter(Boolean).pop() || 'Dashboard';
        const formattedPageName = formatPathName(pathName);
        setPageName(formattedPageName);
        if (path.startsWith('/admin/reports')) {
            setActiveDropdown(0);
        } else if (path.startsWith('/admin/academics')) {
            setActiveDropdown(1);
        } else if (path.startsWith('/admin/finance-management')) {
            setActiveDropdown(2);
        } else if (path.startsWith('/admin/communication')) {
            setActiveDropdown(3);
        } else if (path.startsWith('/admin/staff-management')) {
            setActiveDropdown(4);
        } else if (path.startsWith('/admin/hostel-management')) {
            setActiveDropdown(5);
        } else if (path.startsWith('/admin/transport-management')) {
            setActiveDropdown(6);
        } else if (path.startsWith('/admin/library-management')) {
            setActiveDropdown(7);
        } else if (path.startsWith('/admin/accounting')) {
            setActiveDropdown(9);
        } else if (path.startsWith('/admin/settings')) {
            setActiveDropdown(10);
        }
        console.log("ewsgfrewgherth", path);
    }, [location, setPageName]);

    const toggleDropdown = (index) => {
        setActiveDropdown(prev => (prev === index ? null : index));
    };

    const handleLogout = async () => {
        setIsLoggingOut(true);
        try {
            const response = await axiosInstance.post(api.logout);
            if (response?.data.status === 200) {
                toast.success(response?.data.message);
                setAuthToken('');
                setUserDetails({});
                localStorage.removeItem("authToken");
                navigate("/", { replace: true });
            }
        } catch (error) {
            toast.error(error.response?.data.message || error.message);
        } finally {
            setIsLoggingOut(false);
        }
    }

    const handleOpenSessionsPage = () => {
        navigate("/admin/sessions");
    }

    return (
        <>
            <SidebarWrapper>
                <div className="logo">
                    <img src="/images/logo.png" alt="" />
                </div>
                {
                    userDetails.user_type === 'inst_admin' &&
                    <div className="institution_brief">
                        <div className="brief_inner">
                            <div className="top_part">
                                <div className="image_box">
                                    <i className="fa-solid fa-school"></i>
                                </div>
                                <li>
                                    <h4>{userDetails.institution?.inst_name}</h4>
                                    <p><b>INT ID :</b>{userDetails.institution?.inst_id}</p>
                                </li>
                            </div>
                            <div className="bottom_part">
                                <li>
                                    <p>Ongoing Session :</p>
                                    <span>{userDetails.institution?.ongoingSession?.name}</span>
                                </li>
                                <div className="btn_sec">
                                    <button className="view_btn">View Details</button>
                                    <a className="manage_btn" onClick={handleOpenSessionsPage}>Manage Sessions<i className="fa-solid fa-angle-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {userDetails.user_type === 'super_admin' && (
                    <section className="admin_profile">
                        <div className="admin_profile_card">
                            <div className="admin_profile_identity">
                                <div className="admin_profile_avatar">
                                    {userDetails.image && failedProfileImage !== userDetails.image ? (
                                        <img
                                            src={userDetails.image}
                                            alt={profileName}
                                            onError={() => setFailedProfileImage(userDetails.image)}
                                        />
                                    ) : (
                                        <span aria-hidden="true">{profileInitials}</span>
                                    )}
                                </div>
                                <div className="admin_profile_details">
                                    <h4>{profileName}</h4>
                                    <span className="admin_profile_role">
                                        <i className="fa-solid fa-shield-halved" aria-hidden="true"></i>
                                        {userDetails.user_role || 'Super Admin'}
                                    </span>
                                </div>
                            </div>
                            <NavLink className="admin_profile_settings" to="/admin/settings/account-settings">
                                <i className="fa-solid fa-gear" aria-hidden="true"></i>
                                <span>Account Settings</span>
                                <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                            </NavLink>
                        </div>
                    </section>
                )}
                <div className="sidebar_items">
                    {
                        isAuthLoading ? (
                            <div className="items_inner">
                                {
                                    Array.from({ length: 4 }).map((_, i) => (
                                        <SkeletonLoader key={i} width="100%" height="40px" margin="0 0 10px 0" />
                                    ))
                                }
                            </div>
                        ) : (
                            <ul className="items_inner">
                                <NavLink to="/admin/dashboard">
                                    <i className="fa-solid fa-gauge"></i>
                                    <p>Dashboard</p>
                                </NavLink>
                                {
                                    userDetails.user_type === 'super_admin' &&
                                    <NavLink to="/admin/institutions">
                                        <i className="fa-solid fa-building-user"></i>
                                        <p>Institutions</p>
                                    </NavLink>
                                }
                                {
                                    userDetails.user_type === 'super_admin' &&
                                    <NavLink to="/admin/coupons">
                                        <i className="fa-solid fa-tags"></i>
                                        <p>Coupons</p>
                                    </NavLink>
                                }
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <div className={`dropdown_item ${activeDropdown === 0 ? 'active' : ''}`}>
                                        <div className="dropdown_btn" onClick={() => toggleDropdown(0)}>
                                            <li>
                                                <i className="fa-solid fa-chart-bar prefix"></i>
                                                <span>
                                                    <p>Reports</p>
                                                    <i className="fa-solid fa-angle-right suffix"></i>
                                                </span>
                                            </li>
                                        </div>
                                        <div className="dropdown">
                                            <NavLink to="/admin/reports/school-strength">
                                                <i className="fa-solid fa-users"></i>
                                                <p>School Strength</p>
                                            </NavLink>
                                            <a>
                                                <i className="fa-solid fa-computer"></i>
                                                <p>Classroom Activity</p>
                                            </a>
                                            <a>
                                                <i className="fa-solid fa-id-card-clip"></i>
                                                <p>Student Attendance</p>
                                            </a>
                                            <NavLink to="/admin/reports/academics">
                                                <i className="fa-solid fa-pen-clip"></i>
                                                <p>Academics</p>
                                            </NavLink>
                                            <a>
                                                <i className="fa-solid fa-money-bill"></i>
                                                <p>Fee</p>
                                            </a>
                                        </div>
                                    </div>
                                }
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <div className={`dropdown_item ${activeDropdown === 1 ? 'active' : ''}`}>
                                        <div className="dropdown_btn" onClick={() => toggleDropdown(1)}>
                                            <li>
                                                <i className="fa-solid fa-book prefix"></i>
                                                <span>
                                                    <p>Academics</p>
                                                    <i className="fa-solid fa-angle-right suffix"></i>
                                                </span>
                                            </li>
                                        </div>
                                        <div className="dropdown">
                                            <NavLink to="/admin/academics/student-information">
                                                <i className="fa-solid fa-file-pen"></i>
                                                <p>Student Information</p>
                                            </NavLink>
                                            <NavLink to="/admin/academics/classrooms">
                                                <i className="fa-solid fa-computer"></i>
                                                <p>Classrooms</p>
                                            </NavLink>
                                            <NavLink to="/admin/academics/student-attendence">
                                                <i className="fa-solid fa-id-card-clip"></i>
                                                <p>Student Attendance</p>
                                            </NavLink>
                                            <a>
                                                <i className="fa-solid fa-file-lines"></i>
                                                <p>Report Card</p>
                                            </a>
                                        </div>
                                    </div>
                                }
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <div className={`dropdown_item ${activeDropdown === 2 ? 'active' : ''}`}>
                                        <div className="dropdown_btn" onClick={() => toggleDropdown(2)}>
                                            <li>
                                                <i className="fa-solid fa-sack-dollar prefix"></i>
                                                <span>
                                                    <p>Finance Management</p>
                                                    <i className="fa-solid fa-angle-right suffix"></i>
                                                </span>
                                            </li>
                                        </div>
                                        <div className="dropdown">
                                            <NavLink to="/admin/finance-management/fee-collection">
                                                <i className="fa-solid fa-hand-holding-dollar prefix"></i>
                                                <p>Fee Collection</p>
                                            </NavLink>
                                            <NavLink to="/admin/finance-management/fee-transactions">
                                                <i className="fa-solid fa-file-invoice prefix"></i>
                                                <p>Fee Transactions</p>
                                            </NavLink>
                                            <NavLink to="/admin/finance-management/fee-configuration">
                                                <i className="fa-solid fa-gear prefix"></i>
                                                <p>Fee Configuration</p>
                                            </NavLink>
                                            <NavLink to="/admin/finance-management/discount-fine">
                                                <i className="fa-solid fa-tags prefix"></i>
                                                <p>Discount & Fine</p>
                                            </NavLink>
                                            <NavLink to="/admin/finance-management/accounts">
                                                <i className="fa-solid fa-building-columns prefix"></i>
                                                <p>Bank Accounts</p>
                                            </NavLink>
                                        </div>
                                    </div>
                                }
                                {
                                    // userDetails.user_type === 'inst_admin' &&
                                    <div className={`dropdown_item ${activeDropdown === 3 ? 'active' : ''}`}>
                                        <div className="dropdown_btn" onClick={() => toggleDropdown(3)}>
                                            <li>
                                                <i className="fa-solid fa-headphones prefix"></i>
                                                <span>
                                                    <p>Communication</p>
                                                    <i className="fa-solid fa-angle-right suffix"></i>
                                                </span>
                                            </li>
                                        </div>
                                        <div className="dropdown">
                                            <NavLink to="/admin/communication/message-templates">
                                                <i className="fa-solid fa-message prefix"></i>
                                                <p>Message Templates</p>
                                            </NavLink>
                                            <NavLink to="/admin/communication/control-center">
                                                <i className="fa-solid fa-sliders prefix"></i>
                                                <p>Control Center</p>
                                            </NavLink>
                                            <NavLink to="/admin/communication/institution-wallets">
                                                <i className="fa-solid fa-wallet prefix"></i>
                                                <p>Institution Wallets</p>
                                            </NavLink>
                                        </div>
                                    </div>
                                }
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <div className={`dropdown_item ${activeDropdown === 4 ? 'active' : ''}`}>
                                        <div className="dropdown_btn" onClick={() => toggleDropdown(4)}>
                                            <li>
                                                <i className="fa-solid fa-users-gear prefix"></i>
                                                <span>
                                                    <p>Staff Management</p>
                                                    <i className="fa-solid fa-angle-right suffix"></i>
                                                </span>
                                            </li>
                                        </div>
                                        <div className="dropdown">
                                            <NavLink to="/admin/staff-management/staff-information">
                                                <i className="fa-solid fa-file-pen prefix"></i>
                                                <p>Staff Information</p>
                                            </NavLink>
                                            <a>
                                                <i className="fa-solid fa-id-card-clip prefix"></i>
                                                <p>Staff Attendance</p>
                                            </a>
                                        </div>
                                    </div>
                                }
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <div className={`dropdown_item ${activeDropdown === 5 ? 'active' : ''}`}>
                                        <div className="dropdown_btn" onClick={() => toggleDropdown(5)}>
                                            <li>
                                                <i className="fa-solid fa-building-user prefix"></i>
                                                <span>
                                                    <p>Hostel Management</p>
                                                    <i className="fa-solid fa-angle-right suffix"></i>
                                                </span>
                                            </li>
                                        </div>
                                        <div className="dropdown">
                                            <NavLink to="/admin/hostel-management/hostel-overview">
                                                <i className="fa-solid fa-magnifying-glass-chart prefix"></i>
                                                <p>Overview</p>
                                            </NavLink>
                                            <NavLink to="/admin/hostel-management/residents">
                                                <i className="fa-solid fa-users prefix"></i>
                                                <p>Residents</p>
                                            </NavLink>
                                            <NavLink to="/admin/hostel-management/hostel-rooms">
                                                <i className="fa-solid fa-door-open prefix"></i>
                                                <p>Rooms</p>
                                            </NavLink>
                                            <NavLink to="/admin/hostel-management/hostel-buildings">
                                                <i className="fa-solid fa-building prefix"></i>
                                                <p>Buildings</p>
                                            </NavLink>
                                        </div>
                                    </div>
                                }
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <div className={`dropdown_item ${activeDropdown === 6 ? 'active' : ''}`}>
                                        <div className="dropdown_btn" onClick={() => toggleDropdown(6)}>
                                            <li>
                                                <i className="fa-solid fa-truck-fast prefix"></i>
                                                <span>
                                                    <p>Transport Management</p>
                                                    <i className="fa-solid fa-angle-right suffix"></i>
                                                </span>
                                            </li>
                                        </div>
                                        <div className="dropdown">
                                            <NavLink to="/admin/transport-management/overview">
                                                <i className="fa-solid fa-magnifying-glass-chart prefix"></i>
                                                <p>Overview</p>
                                            </NavLink>
                                            <NavLink to="/admin/transport-management/passengers">
                                                <i className="fa-solid fa-users prefix"></i>
                                                <p>Passengers</p>
                                            </NavLink>
                                            <NavLink to="/admin/transport-management/stopages">
                                                <i className="fa-solid fa-map-location prefix"></i>
                                                <p>Stopages</p>
                                            </NavLink>
                                            <NavLink to="/admin/transport-management/vehicles">
                                                <i className="fa-solid fa-bus prefix"></i>
                                                <p>Vehicles</p>
                                            </NavLink>
                                            <NavLink to="/admin/transport-management/staffs">
                                                <i className="fa-solid fa-users prefix"></i>
                                                <p>Staffs</p>
                                            </NavLink>
                                            <NavLink to="/admin/transport-management/routes">
                                                <i className="fa-solid fa-route prefix"></i>
                                                <p>Routes</p>
                                            </NavLink>
                                        </div>
                                    </div>
                                }
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <div className={`dropdown_item ${activeDropdown === 7 ? 'active' : ''}`}>
                                        <div className="dropdown_btn" onClick={() => toggleDropdown(7)}>
                                            <li>
                                                <i className="fa-solid fa-book prefix"></i>
                                                <span>
                                                    <p>Library Management</p>
                                                    <i className="fa-solid fa-angle-right suffix"></i>
                                                </span>
                                            </li>
                                        </div>
                                        <div className="dropdown">
                                            <NavLink to="/admin/library-management/library-overview">
                                                <i className="fa-solid fa-magnifying-glass-chart prefix"></i>
                                                <p>Overview</p>
                                            </NavLink>
                                            <NavLink to="/admin/library-management/book-catelog">
                                                <i className="fa-solid fa-book-open prefix"></i>
                                                <p>Book Catelog</p>
                                            </NavLink>
                                            <NavLink to="/admin/library-management/library-member">
                                                <i className="fa-solid fa-users prefix"></i>
                                                <p>Library Members</p>
                                            </NavLink>
                                        </div>
                                    </div>
                                }
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <div className={`dropdown_item ${activeDropdown === 8 ? 'active' : ''}`}>
                                        <div className="dropdown_btn" onClick={() => toggleDropdown(8)}>
                                            <li>
                                                <i className="fa-solid fa-user-shield prefix"></i>
                                                <span>
                                                    <p>Administration</p>
                                                    <i className="fa-solid fa-angle-right suffix"></i>
                                                </span>
                                            </li>
                                        </div>
                                        <div className="dropdown">
                                            <a>
                                                <i className="fa-solid fa-certificate prefix"></i>
                                                <p>Certificates</p>
                                            </a>
                                            <a>
                                                <i className="fa-solid fa-id-card-clip prefix"></i>
                                                <p>Id Cards</p>
                                            </a>
                                        </div>
                                    </div>
                                }
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <div className={`dropdown_item ${activeDropdown === 9 ? 'active' : ''}`}>
                                        <div className="dropdown_btn" onClick={() => toggleDropdown(9)}>
                                            <li>
                                                <i className="fa-solid fa-circle-dollar-to-slot prefix"></i>
                                                <span>
                                                    <p>Accounting</p>
                                                    <i className="fa-solid fa-angle-right suffix"></i>
                                                </span>
                                            </li>
                                        </div>
                                        <div className="dropdown">
                                            <NavLink to="/admin/accounting/expense-management">
                                                <i className="fa-solid fa-receipt"></i>
                                                <p>Expense Management</p>
                                            </NavLink>
                                            <NavLink to="/admin/accounting/stock-management">
                                                <i className="fa-solid fa-boxes-stacked prefix"></i>
                                                <p>Stock Management</p>
                                            </NavLink>
                                        </div>
                                    </div>
                                }
                                <div className={`dropdown_item ${activeDropdown === 10 ? 'active' : ''}`}>
                                    <div className="dropdown_btn" onClick={() => toggleDropdown(10)}>
                                        <li>
                                            <i className="fa-solid fa-gears prefix"></i>
                                            <span>
                                                <p>Settings</p>
                                                <i className="fa-solid fa-angle-right suffix"></i>
                                            </span>
                                        </li>
                                    </div>
                                    <div className="dropdown">
                                        <a>
                                            <i className="fa-solid fa-mobile prefix"></i>
                                            <p>Device Settings</p>
                                        </a>
                                        {
                                            userDetails.user_type === 'inst_admin' &&
                                            <NavLink to="/admin/settings/profile-settings">
                                                <i className="fa-solid fa-user-gear prefix"></i>
                                                <p>Manage Profile</p>
                                            </NavLink>
                                        }
                                        {
                                            userDetails.user_type === 'inst_admin' &&
                                            <NavLink to="/admin/settings/subject-settings">
                                                <i className="fa-solid fa-book-open"></i>
                                                <p>Subjects</p>
                                            </NavLink>
                                        }
                                        <NavLink to="/admin/settings/account-settings">
                                            <i className="fa-solid fa-user"></i>
                                            <p>Account Setting</p>
                                        </NavLink>
                                        {
                                            userDetails.user_type === 'inst_admin' &&
                                            <NavLink to="/admin/settings/time-tables">
                                                <i className="fa-solid fa-calendar-days"></i>
                                                <p>Time Table</p>
                                            </NavLink>
                                        }
                                        <a>
                                            <i className="fa-solid fa-gear prefix"></i>
                                            <p>General Settings</p>
                                        </a>
                                        {
                                            userDetails.user_type === 'super_admin' &&
                                            <NavLink to="/admin/settings/subscription-setting">
                                                <i className="fa-solid fa-box-archive prefix"></i>
                                                <p>Subscriptions</p>
                                            </NavLink>
                                        }
                                        {
                                            userDetails.user_type === 'super_admin' &&
                                            <NavLink to="/admin/settings/state-cities">
                                                <i className="fa-solid fa-city prefix"></i>
                                                <p>State & Cities</p>
                                            </NavLink>
                                        }
                                        <NavLink to="/admin/settings/roles-permissions">
                                            <i className="fa-solid fa-file-shield prefix"></i>
                                            <p>Roles & Permissions</p>
                                        </NavLink>
                                        {
                                            userDetails.user_type === 'inst_admin' &&
                                            <a>
                                                <i className="fa-solid fa-hand-holding-hand prefix"></i>
                                                <p>Preferences</p>
                                            </a>
                                        }
                                    </div>
                                </div>
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <NavLink to="/admin/billing">
                                        <i className="fa-solid fa-hand-holding-dollar"></i>
                                        <p>Billing</p>
                                    </NavLink>
                                }
                                {
                                    userDetails.user_type === 'inst_admin' &&
                                    <NavLink to="/admin/alumni">
                                        <i className="fa-solid fa-graduation-cap"></i>
                                        <p>Alumni</p>
                                    </NavLink>
                                }
                            </ul>
                        )
                    }
                </div>
                <div className="auth_btn">
                    <a className={isLoggingOut ? 'disable' : ''} onClick={handleLogout}>
                        {
                            isLoggingOut ? (
                                <ButtonLoader />
                            ) : (
                                <>
                                    <i className="fa-solid fa-right-from-bracket"></i>
                                    <span>Log Out</span>
                                </>
                            )
                        }
                    </a>
                </div>
            </SidebarWrapper>
        </>
    );
}

export default Sidebar;
